import {
  U21Chip,
  U21ChipProps,
  U21MenuLayout,
} from 'app/shared/u21-ui/components';
import { useGetAlert } from 'app/modules/alerts/queries/useGetAlert';
import { useSelector } from 'react-redux';
import { selectHasReassignAlertPermission } from 'app/modules/alerts/selectors';
import { IconFlagArrow } from 'app/shared/components/Icons/IconFlagArrow';
import { useCallback, useState } from 'react';
import { ReassignMenuList } from 'app/modules/alerts/components/SideBySide/ReassignMenuList';
import { AgentChip } from 'app/shared/components/AgentChip';

interface Props {
  id: number;
  onSuccess?: () => void;
}

export const Reassign = (props: Props) => {
  const { id, onSuccess: onSuccessProp } = props;

  const hasReassignAlertPermission = useSelector(
    selectHasReassignAlertPermission,
  );

  const [open, setOpen] = useState(false);

  const { alert } = useGetAlert(id);

  const onSuccess = useCallback(async () => {
    setOpen(false);
    onSuccessProp?.();
  }, [onSuccessProp]);

  if (!alert) {
    return null;
  }

  const commonChipProps: Partial<Omit<U21ChipProps, 'id'>> = {
    color: 'primary',
    variant: 'ghost',
  };

  if (
    !hasReassignAlertPermission ||
    alert.status === 'CLOSED' ||
    alert.status === 'IN_REVIEW'
  ) {
    if (alert.assigned_to_id > 0) {
      return (
        <AgentChip
          id={alert.assigned_to_id}
          onClick={undefined}
          to={undefined}
          {...commonChipProps}
        />
      );
    }
    return (
      <U21Chip icon={<IconFlagArrow />} {...commonChipProps}>
        Unassigned
      </U21Chip>
    );
  }

  return (
    <U21MenuLayout
      onClose={(e) => {
        e.stopPropagation();
        setOpen(false);
      }}
      trigger={
        alert.assigned_to_id > 0 ? (
          <AgentChip
            id={alert.assigned_to_id}
            onClick={() => setOpen(true)}
            to={undefined}
            {...commonChipProps}
          />
        ) : (
          <U21Chip
            icon={<IconFlagArrow />}
            onClick={() => setOpen(true)}
            {...commonChipProps}
          >
            Unassigned
          </U21Chip>
        )
      }
      open={open}
    >
      <ReassignMenuList id={id} onSuccess={onSuccess} />
    </U21MenuLayout>
  );
};
